export const colors = {
  primary: "#8DB56D",
};
